<h2 mat-dialog-title>{{'Remito' | translate}}</h2>

<div mat-dialog-content>

  <ng-container *ngIf="!isSearching && item != null">

    <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Código</b>: {{item?.Codigo}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Proveedor</b>: {{item?.ProveedorNombre}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Fecha Entrega</b>: {{item?.FechaEntrega | date:'dd/MM/yyyy HH:mm'}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Observaciones</b>: {{item?.Observacion}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="item.RemitoUrl != null && item.RemitoUrl.length > 0" style="margin-top: 20px;">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 15px;">
            <a matLine href="{{item.RemitoUrl}}" target="_blank">Ver remito</a>
          </div>
        </mat-expansion-panel>
      </div>

    </div>

    <hr />

    <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 10px;">

      <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
        <mat-label style="font-weight: bold;">Detalle de materiales entregados:</mat-label>
      </div>
      <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isRemitoItemsSearching">
        <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      </div>
      <ejs-grid #detallesGrid [dataSource]='item.RemitoDetalle' [allowPaging]="true" [allowSorting]="true"
        [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
        [allowResizing]='true' *ngIf="!isRemitoItemsSearching">
        <e-columns>
          <e-column field='PedidoId' headerText='Nro. Pedido' width=80></e-column>
          <e-column field='MaterialNombre' headerText='Material'></e-column>
          <e-column field='Detalle' headerText='Detalle'></e-column>
          <e-column field='Cantidad' headerText='Cantidad'>
            <ng-template #template let-data>
              {{data.Cantidad}} {{data.MaterialUnidadMedidaNombre}}
            </ng-template>
          </e-column>
        </e-columns>
      </ejs-grid>

    </div>

  </ng-container>

</div>

<br />

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="warn" (click)="onDecline()" class="zb-button">{{buttonCancelText}}</button>
  </div>
</div>